/** @typedef { import('rxjs').Observable } Observable */
/** @typedef { import('rxjs').ObservedValueOf } ObservedValueOf */

import axios from 'axios';
import { from } from 'rxjs';

export const bulkShippingUpdate = (bulkUpdateRequest) => {
  const post = axios.post('/bulk/update/shipping', bulkUpdateRequest).then((res) => res.data);

  const request$ = from(post);
  return request$;
};

export const bulkUpdateShipping = (bulkUpdateRequest) => {
  const post = axios.post('/bulk/update/bulkshipping', bulkUpdateRequest).then((res) => res.data);

  const request$ = from(post);
  return request$;
};

export const updateBulkShipping = (bulkUpdateRequest) => {
  return axios.post('/bulk/update/bulkshipping', bulkUpdateRequest);
};

export const bulkUpdateExternalFulfillment = (bulkUpdateRequest) => {
  const post = axios.post('/bulk/update/bulkExternalFulfillment', bulkUpdateRequest).then((res) => res.data);

  const request$ = from(post);
  return request$;
};

export const bulkUpdateSalesOrders = (salesOrderIds = [], shipmentConfiguration) => {
  const post = axios
    .post('/salesOrder/bulk/shippingUpdate', {
      ...shipmentConfiguration,
      salesOrderIds,
    })
    .then((res) => res.data);

  const request$ = from(post);
  return request$;
};

const idSetsToFilterRequest = (idSets) =>
  idSets.map(({ salesOrderIds, fulfillmentPlanId, fulfillmentPlanSetId }) => ({
    salesOrderIds,
    fulfillmentPlanId,
    fulfillmentPlanSetId,
  }));

export const getJobData = (idSets) => {
  const request = idSetsToFilterRequest(idSets);
  const post = axios.post('/bulk/update/getJobData', request).then((res) => res.data);

  const request$ = from(post);
  return request$;
};

/**
 * @typedef {object} GetBulkJobDataRequest
 * @property {string[]} [fulfillmentPlanIds]
 * @property {string} [fulfillmentPlanSetId]
 * @property {string} [searchTerm]
 * @property {string[]} [storeGuid]
 * @property {string} [orderGridStatus]
 */

/**
 * @typedef {object} BulkUpdateJobDataResponse
 * @property {number} fulfillmentPlanCount
 * @property {string[]} serviceIds
 * @property {string} bulkFulfillmentPlanType
 * @property {string} bulkFulfillmentType
 * @property {string} [bulkUpdateJobGuid]
 * @property {number} [sellerFulfillmentProviderId]
 * @property {number} bulkFulfillmentPlanShippingStrategiesCount
 * @property {object[]} availableAdditionalOptions
 */

/**
 * @param {GetBulkJobDataRequest} request
 * @returns {Observable<ObservedValueOf<Promise<BulkUpdateJobDataResponse>>>}
 */
export const getBulkJobData = (request) => {
  const post = axios.post('/bulk/update/getBulkJobData', request).then((res) => res.data);

  const request$ = from(post);
  return request$;
};

/**
 * @param {GetBulkJobDataRequest} request
 * @returns {Promise<AxiosResponse<BulkUpdateJobDataResponse>>}
 */
export const bulkGetBulkJobData = (request) => {
  return axios.post('/bulk/update/getBulkJobData', request);
};

export const bulkAddNoteUpdate = (request) => {
  const post = axios.post('/bulk/update/bulkCreateNote', request).then((res) => res.data);

  const request$ = from(post);
  return request$;
};

export const bulkUpdateAddNote = (request) => {
  const post = axios.post('/bulk/update/createNote', request).then((res) => res.data);

  const request$ = from(post);
  return request$;
};

export const bulkUpdateAddTaxIds = (request) => {
  const post = axios.post('/bulk/update/bulkFulfillmentPlanTaxIds', request).then((res) => res.data);

  const request$ = from(post);
  return request$;
};

export const bulkUpdateSetShipByDate = (request) => {
  const post = axios.post('/bulk/update/shipByDate', request).then((res) => res.data);

  const request$ = from(post);
  return request$;
};

export const bulkSetShipByDateUpdate = (request) => {
  const post = axios.post('/bulk/update/bulkShipByDate', request).then((res) => res.data);

  const request$ = from(post);
  return request$;
};

export const bulkDoNotNotifyMarketplace = (idSets) => {
  const request = idSetsToFilterRequest(idSets);
  const post = axios.post('/bulk/update/doNotNotifyMarketplace', request).then((res) => res.data);

  const request$ = from(post);
  return request$;
};

export const bulkUpdateDoNotNotifyMarketplace = (request) => {
  const post = axios.post('/bulk/update/bulkDoNotNotifyMarketplace', request).then((res) => res.data);

  const request$ = from(post);
  return request$;
};

export const bulkUpdateTemplates = ({ filters, shipmentEmailTemplateId, deliveryEmailTemplateId, packingSlipTemplateId }) => {
  const request = {
    filters,
    shipmentEmailTemplateId,
    deliveryEmailTemplateId,
    packingSlipTemplateId,
  };
  const post = axios.post('/bulk/update/templates', request).then((res) => res.data);

  const request$ = from(post);
  return request$;
};

export const bulkTemplatesUpdate = ({ bulkUpdateJobGuid, shipmentEmailTemplateId, deliveryEmailTemplateId, packingSlipTemplateId }) => {
  const request = {
    bulkUpdateJobGuid,
    shipmentEmailTemplateId,
    deliveryEmailTemplateId,
    packingSlipTemplateId,
  };
  const post = axios.post('/bulk/update/bulkTemplates', request).then((res) => res.data);

  const request$ = from(post);
  return request$;
};

export const bulkUpdateAddWeight = ({ filters, weight }) => {
  const request = {
    filters: idSetsToFilterRequest(filters),
    weight,
  };
  const post = axios.post('/bulk/update/addWeight', request).then((res) => res.data);

  const request$ = from(post);
  return request$;
};

export const bulkAddWeightUpdate = ({ bulkUpdateJobGuid, weight }) => {
  const request = {
    bulkUpdateJobGuid,
    weight,
  };
  const post = axios.post('/bulk/update/bulkAddWeight', request).then((res) => res.data);

  const request$ = from(post);
  return request$;
};

export const getBulkDutiesCountByCost = (request) => {
  const post = axios.post('/ddp/getBulkDutiesCountByCost', request).then((res) => res.data);

  const request$ = from(post);
  return request$;
};

/**
 * @param {string} bulkUpdateJobGuid
 * @returns {Promise<AxiosResponse>}
 */
export const bulkReship = (bulkUpdateJobGuid) => {
  return axios.post('/bulk/update/reship', { bulkUpdateJobGuid });
};
